import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { PropertyService } from '../../../../features/property/services/property.service';
import { PropertyLikeService } from '../../../../features/property/services/property-like.service';

import { Property, UserLikesResponse } from '../../../../features/property/models/property.model';
import { filter, forkJoin, of, switchMap, take, tap } from 'rxjs';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../../general/components/loader/loader.component';
import { SaveButtonComponent } from "../../../../features/property/components/save-button/save-button";
import { HapticsService } from '../../../general/services/haptics.service';

@Component({
  selector: 'app-like-list',
  imports: [
    CommonModule,
    MatSpinner,
    MatProgressSpinnerModule,
    MatIconModule,
    MatListModule,
    LoaderComponent,
    SaveButtonComponent
],
  templateUrl: './like-list.html',
  styleUrl: './like-list.scss',
})
export class LikeList implements OnInit {
  private authService = inject(AuthService);
  private propertyService = inject(PropertyService);
  private likeService = inject(PropertyLikeService);
  private cdr = inject(ChangeDetectorRef);
  private haptics = inject(HapticsService);
  private router = inject(Router);

  @Output() totalLikesChange = new EventEmitter<number>();
  properties: Property[] = [];
  loading = false;
  totalUserLikes = 0;
  
  ngOnInit() {
    this.loading = true;
    this.authService.user$.pipe(
      filter(user => user !== null),
      take(1),
      tap((user) => console.log('Real user:', user)),
      switchMap(user => this.likeService.getUserLikes(user.id)),
      tap((likes: UserLikesResponse[]) => {
        this.totalUserLikes = likes.length;   // <-- total count
        console.log(`User has ${this.totalUserLikes} liked properties`);
        this.totalLikesChange.emit(this.totalUserLikes);
      }),
      tap(response => console.log('GET USER LIKES RAW RESPONSE:', response)),
      switchMap((likes: UserLikesResponse[]) => {
        if (likes.length === 0) {
          return of([] as Property[]);
        }
        return forkJoin(
          likes.map(like =>
            this.propertyService.getPropertyById(like.propertyId).pipe(
              tap(p => console.log('Loaded property:', p))
            )
          )
        );
      }),
      tap((properties: Property[]) => {
        console.log('✅ ALL PROPERTIES LOADED:', properties);
        this.properties = properties;
        this.properties.map(p => p.liked = true);
        setTimeout(() => {
          this.loading = false;
          this.cdr.detectChanges();
        }, 0);
      })
    ).subscribe({
      error: err => console.error('💥 Likes error:', err),
    });
  }

  gotoProperty = (propertyId: string) => {
    this.haptics.click();
    console.log('clicked propertyId', propertyId);
    console.log('🚀 NAVIGATING TO:', '/property', propertyId);
    console.log('FULL URL:', `/property/${propertyId}`);
    this.router.navigate(['/property', propertyId]);
  }
}
